(function () {
    'use strict';

    angular.module("imApp").factory("gridExportsService", ['$ihttp', function ($ihttp) {
        let service = {
            listGridExports: function (parms) {
                return $ihttp.post({
                    method: 1879,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
